function ReferEarnIcon({ iconStyle }) {
  return (
    <svg
      className={iconStyle}
      width='6'
      height='8'
      viewBox='0 0 6 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.84 7.5402H2.34C1.19 7.5402 0.26 6.5802 0.26 5.3902C0.26 4.9802 0.6 4.6402 1.01 4.6402C1.42 4.6402 1.76 4.9802 1.76 5.3902C1.76 5.7502 2.02 6.0402 2.34 6.0402H3.84C4.07 6.0402 4.25 5.8302 4.25 5.5702C4.25 5.2202 4.19 5.2002 3.96 5.1202L1.55 4.2802C0.68 3.9802 0.25 3.3702 0.25 2.4202C0.25 1.3402 1.11 0.450195 2.16 0.450195H3.66C4.81 0.450195 5.74 1.4102 5.74 2.6002C5.74 3.0102 5.4 3.3502 4.99 3.3502C4.58 3.3502 4.24 3.0102 4.24 2.6002C4.24 2.2402 3.98 1.9502 3.66 1.9502H2.16C1.93 1.9502 1.75 2.1602 1.75 2.4202C1.75 2.7702 1.81 2.7902 2.04 2.8702L4.45 3.7102C5.32 4.0202 5.74 4.6302 5.74 5.5702C5.75 6.6602 4.89 7.5402 3.84 7.5402Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default ReferEarnIcon;
